import { render, staticRenderFns } from "./TextractForm.vue?vue&type=template&id=f02df2ae&scoped=true&"
import script from "./TextractForm.vue?vue&type=script&lang=js&"
export * from "./TextractForm.vue?vue&type=script&lang=js&"
import style0 from "./TextractForm.vue?vue&type=style&index=0&id=f02df2ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02df2ae",
  null
  
)

export default component.exports